/**
 * De qué tipografía sale cada ícono.
 *
 * FARO carga **una sola**: Material Symbols Outlined, que es la fuente por
 * defecto de `<mat-icon>` (`app.config.ts`) y tiene todos los nombres. Antes
 * eran dos (Material Icons Outlined y Symbols), y un ligature que la tipografía
 * aplicada no conocía **no caía a otro ícono**: escribía el nombre en crudo o
 * dibujaba un rectángulo. Pasaba con la puesta (`table_lamp`), con los estados
 * E1 y E5 de la luminaria y con todo `*_outline`.
 *
 * Qué ícono va para cada concepto: `docs/ICONOS.md`.
 */

/** El nombre del `fontSet` de Material Symbols, como lo espera `<mat-icon>`. */
export const FONT_SIMBOLOS = 'material-symbols-outlined';

/**
 * Vacío quiere decir "la tipografía por defecto", que ya es Material Symbols.
 *
 * @deprecated Ya no hace falta elegir tipografía: dibujá `<mat-icon>` sin
 * `fontSet`. Queda para no romper a quien todavía lo llama.
 */
export function fontSetDeIcono(_icono: string): string {
  return '';
}
